<template>
  <div ref="disperseAnnPanel" class="disperseAnn"></div>
</template>
<script>
import * as echarts from "echarts";
import { debounce } from "lodash";
export default {
  name: "DisperseAnnPanel",
  props: {
    seriesData: {
      type: Array,
      required: true,
    },
  },
  watch: {
    seriesData: {
      immediate: true,
      handler(newVal) {
        this.option.series[0].data = newVal;
        this.chartInstance?.setOption(this.option);
      }
    },
    // 监听 option 变化并更新图表
    option: {
      handler(newOption) {
        this.chartInstance?.setOption(newOption);
      },
      deep: true,
    },
  },
  data() {
    return {
      myChart: null,
      chartInstance: null,
      option: {
        color: ["#00f6ff", "#46ff8c", "#fece4b", "#ABABAB"],
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "center",
          right: "10%",
          orient: "vertical",
          itemGap: 25,
          textStyle: {
            color: "#ffffff",
          },
        },
        series: [
          {
            center: ["30%", "50%"],
            name: this.$t("screen.paidOrdersNumber"),
            type: "pie",
            radius: ["47%", "75%"],
            padAngle: 5,
            itemStyle: {
              borderRadius: 12,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              scaleSize: 10,
              label: {
                formatter: "{b}\n{d}%",
                show: true,
                fontSize: 20,
                color: "#ffffff",
              },
            },
            labelLine: {
              show: false,
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.initChart();
    window.addEventListener("resize", this.resizeChart);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart);
    this.chartInstance?.dispose();
  },
  methods: {
    initChart() {
      this.option.series[0].data = this.seriesData;
      if (!this.$refs.disperseAnnPanel) return;
      this.chartInstance = echarts.init(this.$refs.disperseAnnPanel);
      this.chartInstance.setOption(this.option);
      this.$emit("ready");
    },
    resizeChart: debounce(function () {
      this.chartInstance?.resize();
    }, 200),
  },
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>